import { Controller } from "@hotwired/stimulus"

// Opens a full price-detail modal when the user clicks a watchlist card.
// Groups rows[1..] by pharmacy with expand/collapse for sub-rows.
export default class extends Controller {
  static targets = ["modal", "subrows"]

  open(event) {
    if (event.target.closest(".modal-exclude")) return
    if (!this.modalTarget.classList.contains("hidden")) return
    // Prevent space from scrolling only when it will activate the card
    if (event.key === " ") event.preventDefault()
    this.modalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  close(event) {
    // Stop propagation so the click doesn't bubble to the card and re-open the modal
    if (event) event.stopPropagation()

    this.modalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  toggleGroup(event) {
    // Stop propagation so the click doesn't bubble to the card's open() handler
    event.stopPropagation()

    const button = event.currentTarget
    const groupDiv = button.closest("[data-group]")
    if (!groupDiv) return

    const subrows = groupDiv.querySelector("[data-subrows]")
    const chevron = button.querySelector("[data-chevron]")

    if (subrows) {
      subrows.classList.toggle("hidden")
      if (chevron) chevron.classList.toggle("rotate-180")
    }
  }
}
